"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGetShiftsWorkMinutes = void 0;
const store_1 = require("@app/store");
const util_1 = require("@app/util");
const moment_1 = __importDefault(require("moment"));
const react_hook_form_1 = require("react-hook-form");
const unavailability_context_1 = require("../unavailability-context");
const useGetShiftsWorkMinutes = () => {
    const { formControl } = (0, unavailability_context_1.useUnavailability)();
    const _userId = (0, react_hook_form_1.useWatch)({ control: formControl, name: 'user' });
    const _period = (0, react_hook_form_1.useWatch)({ control: formControl, name: 'period' });
    const _periodStart = _period?.start;
    const _periodEnd = _period?.end;
    const shifts = (0, store_1.useRootSelector)((state) => state.shifts);
    const relevantShifts = (0, util_1.isValue)(_periodStart) && (0, util_1.isValue)(_periodEnd)
        ? shifts
            .filter((shift) => shift.userId === _userId)
            .filter((shift) => (0, moment_1.default)(shift?.period?.start).isBetween(_periodStart, _periodEnd, 'day', '[]'))
        : [];
    const workMinutesTotalShifts = relevantShifts.reduce((acc, curr) => acc +
        (curr.stats?.reduce((acc, curr) => acc + (curr?.workMinutes ?? 0), 0) ?? 0), 0);
    return workMinutesTotalShifts;
};
exports.useGetShiftsWorkMinutes = useGetShiftsWorkMinutes;
